// Ajax Forms

// Global function object
if (typeof ePortfolio === "undefined") var ePortfolio = {};

(function ($) {
  ePortfolio.processAjaxRespose = function (data) {
    if (data && data.hasOwnProperty("next_url")) {
      ePortfolio.openNextForm(data);
    } else if (data && data.hasOwnProperty("reload")) {
      location.reload();
    } else if (data && data.hasOwnProperty("goto_url")) {
      window.location.href = data.goto_url;
    } else if (data && data.hasOwnProperty("remove")) {
      $(data.remove).fadeOut();
    } else if (data && data.hasOwnProperty("append")) {
      $(data.append).appendTo(data.appendTo);
    }

    if (data && data.hasOwnProperty("refresh")) {
      if (data.refresh.constructor === Array) {
        for (var i = 0; i < data.refresh.length; i++) {
          ePortfolio.ajaxGet(data.refresh[i]);
        }
      } else {
        ePortfolio.ajaxGet(data.refresh);
      }
    }

    if (data && data.hasOwnProperty("update")) {
      var update = JSON.parse(data.update);
      if (typeof update == "object") {
        $.each(update, function (selector, updatedText) {
          $(selector).text(updatedText);
        });
      } else {
        // I dunno
      }
    }

    if (data && data.hasOwnProperty("close")) {
      $.featherlight.close();
    }

    if (data && data.hasOwnProperty("close_current")) {
      $.featherlight.close();
    }

    if (data && data.hasOwnProperty("alert_message")) {
      ePortfolio.ajaxAlert(data);
    }
  };

  ePortfolio.ajaxAlert = function (msg) {
    var alert, type;

    // if (msg.name) {
    //     alert = msg.name;
    //     type = 'error';
    // } else if (msg.title) {
    //     alert = msg.title;
    //     type = 'error';
    // } else if (msg.file) {
    //     alert = msg.file;
    //     type = 'error'
    // } else
    if (msg.alert_message) {
      alert = msg.alert_message;
      type = msg.alert_class;
    } else {
      alert = msg;
      type = "error";
    }

    if (type === "error") {
      toastr.error(alert);
    } else if (type === "success") {
      toastr.success(alert);
    } else {
      toastr.info(alert);
    }
  };

  ePortfolio.openNextForm = function (msg) {
    var current = $.featherlight.current();
    if (current !== null) current.close(); // $.featherlight.current(); returns null if no current lightbox
    $.featherlight(msg.next_url, {
      closeTrigger: msg.disable_close ? null : "click",
    });
  };

  ePortfolio.initAjaxForm = function () {
    ePortfolio.sendFormUsingAjax();
    ePortfolio.files();
    ePortfolio.links();
    ePortfolio.disableFields();
    ePortfolio.quickApprove();
    ePortfolio.timepicker();
    ePortfolio.providerSelect2();
    ePortfolio.spectrumColorPicker();
  };

  ePortfolio.timepicker = function () {
    $("input.durationBox").datebox({
      overrideDurationOrder: ["h", "i"],
      overrideDurationFormat: "%Dl:%DM",
      durationStep: "15",
      mode: "durationbox",
    });
  };

  ePortfolio.disableFields = function () {
    // prevent disabling methods (PUT, DELETE etc) and tokens (auth)
    $(
      "form.disabled :input:not(.immune , [name='_method'], [name='_token'])"
    ).prop("disabled", true);
    $("form.disabled .delete-file").addClass("disabled");
    $("form.disabled .btn-enable-form-edit").show();
    // $('.evidence-link-title, .evidence-link-url').removeClass('editable');

    $(document).off("click", "form.disabled input[type=url]");
    $(document).on("click", "form.disabled input[type=url]", function (e) {
      e.preventDefault();
      var link = $(this).val();
      // console.log($(this));
      // console.log(link);
      window.open(link);
    });

    // Edit button on the Activity view is clicked - enable the form and show submit buttons
    $(".btn-enable-form-edit").click(function (event) {
      // console.log('things');

      // unbind the URL links
      $(document).off("click", "form.disabled input[type=url]");

      $("input.durationBox").datebox("enable");

      // enable inputs
      $(this)
        .parents("form")
        .find(":input")
        .each(function (index, element) {
          $(this).prop("disabled", false);
        });

      $(this)
        .parents("form")
        .find(".delete-file")
        .each(function (index, element) {
          $(this).removeClass("disabled");
        });
      // show submit buttons
      $(".form-edit-submits").removeClass("hidden");

      // show evidence related edit buttons (and make room for them)
      $(".evidence-link-title, .evidence-link-url").addClass("editable");
      $(".edit-visible-only").fadeIn();

      $("form.disabled").removeClass("disabled");

      // hide the edit button
      $(this).fadeOut();
    });
  };

  ePortfolio.sendFormUsingAjax = function () {
    // send forms with class of ajaxForm over AJAX!
    $(document).off("click", ".ajaxForm *[type=submit]:not(.external)");
    $(document).on(
      "click",
      ".ajaxForm *[type=submit]:not(.external)",
      function (e) {
        // $(document).find('.ajaxForm input[type=submit]').click(function (e) {
        var input = $(this);
        var form = $(this).closest("form");
        var validatedForm = form.parsley();

        // perform AJAX only if the form is valid
        if (validatedForm.isValid()) {
          e.preventDefault();
          $("#file").prop("disabled", true); // disable file input fields, so the files are not uploaded again

          // var methodField = $(form).find('input[name=_method]');
          // var method = methodField.length ? methodField.first().val() : form.attr('method');
          var method = form.attr("method");
          var submitType = $(this).attr("name");

          if (method == "GET") {
            var data = form.serialize();
          } else {
            var data = new FormData(form[0]);
            data.append(submitType, true);
          }

          $.ajax({
            url: form.attr("action"),
            type: method,
            data: data,
            dataType: "json",
            processData: false,
            contentType: false,
            headers: {
              "X-CSRF-Token": $("meta[name=csrf-token]").attr("content"),
            },
            beforeSend: function () {
              input.button("loading");
            },
            success: function (data) {
              input.button("reset");
              // console.dir(data);
              ePortfolio.processAjaxRespose(data);
            },
            error: function (data, response, jqXHR) {
              input.button("reset");
              var errors = $.parseJSON(data.responseText);
              console.log(errors);
              $.each(errors, function (index, value) {
                toastr.error(value);
              });
            },
            complete: function () {
              $("#file").prop("disabled", false); // re-enable file input field
            },
          });
        }
      }
    );
  };

  ePortfolio.files = function () {
    // add file to activity
    // $('#file').change(function() {
    // $(document).one('change', '#file', function() {
    $(document).off("change", "#file");
    $(document).on("change", "#file", function () {
      var file = $("input[type=file]")[0].files[0];

      if (file) {
        // to cover for the change event that is selecting no file

        var form = $(this).closest(".ajaxForm > form");
        var input = $(this);
        var activityId = form.attr("data-activity-id");
        var data = new FormData();
        data.append("file", $("input[type=file]")[0].files[0]);
        var prog = $(".file-upload-progress .progress-bar");

        $.ajax({
          xhr: function () {
            var xhr = new window.XMLHttpRequest();

            xhr.upload.addEventListener(
              "progress",
              function (evt) {
                if (evt.lengthComputable) {
                  var percentComplete = evt.loaded / evt.total;
                  percentComplete = parseInt(percentComplete * 100);
                  // console.log(percentComplete);
                  prog.attr("aria-valuenow", percentComplete);
                  prog.css("width", percentComplete + "%");
                  $("span", prog).text(percentComplete + "% uploaded");

                  if (percentComplete === 100) {
                    // console.log("100%");
                    prog.parent().fadeOut();
                  }
                } else {
                  // console.log("evt.lengthComputable not");
                }
              },
              false
            );

            return xhr;
          },
          url: "/file/" + activityId,
          type: "POST",
          data: data,
          dataType: "json",
          processData: false,
          contentType: false,
          headers: {
            "X-CSRF-Token": $("meta[name=csrf-token]").attr("content"),
          },
          beforeSend: function () {
            prog.parent().show();
          },
          success: function (data) {
            // console.dir(data);
            ePortfolio.processAjaxRespose(data);
          },
          error: function (data) {
            var errors = $.parseJSON(data.responseText);
            console.log(errors);
            $.each(errors, function (index, value) {
              toastr.error(value);
            });
          },
        });
      }
    });

    // delete file
    $(document).off("click", ".delete-file");
    $(document).on("click", ".delete-file", function (e) {
      // $(document).one('click', '.delete-file', function(e) {
      e.preventDefault();
      var form = $(this).closest(".ajaxForm > form");
      var fileId = $(this).attr("data-fileId");

      $.ajax({
        url: "/file/delete/" + fileId,
        type: "POST",
        data: null,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data, form);
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });
  };

  ePortfolio.links = function () {
    // add link to activity
    $(document).off("click", ".btn-add-link");
    $(document).on("click", ".btn-add-link", function (e) {
      e.preventDefault();
      var link_title = $(".add-link #link_title").val();
      var link_url = $(".add-link #link_url").val();
      var form = $(this).closest(".ajaxForm > form");
      var activityId = form.attr("data-activity-id");
      var data = new FormData();
      data.append("link_title", link_title);
      data.append("link_url", link_url);

      $.ajax({
        url: "/link/" + activityId,
        type: "POST",
        data: data,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        beforeSend: function () {},
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data);
          // empty the fields for the add new link form
          $(".add-link #link_title").val("");
          $(".add-link #link_url").val("");
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });

    // delete link
    $(document).off("click", ".delete-link");
    $(document).on("click", ".delete-link", function (e) {
      var form = $(this).closest(".ajaxForm > form");
      var linkId = $(this).parent().attr("data-link-id");

      $.ajax({
        url: "/link/delete/" + linkId,
        type: "POST",
        data: null,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data, form);
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });

    //update link
    $(document).off("click", ".save-link");
    $(document).on("click", ".save-link", function (e) {
      e.preventDefault();
      var link_id = $(this).parent().attr("data-link-id");
      var link_title = $("#link_title_" + link_id).val();
      var link_url = $("#link_url_" + link_id).val();
      var data = new FormData();
      data.append("link_title", link_title);
      data.append("link_url", link_url);

      // console.log("title: " + link_title);
      // console.log("url: " + link_url);

      $.ajax({
        url: "/link/update/" + link_id,
        type: "POST",
        data: data,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        beforeSend: function () {},
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data);
          // empty the fields for the add new link form
          $("#link_title", context).val("");
          $("#link_url", context).val("");
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });
  };

  ePortfolio.quickApprove = function () {
    $(document).off("click", ".btn-quick-approve");
    $(document).on("click", ".btn-quick-approve", function (e) {
      e.preventDefault();
      var activityId = $(this).attr("data-quick-approve-activity");
      var textField = $("#text-for-" + activityId);
      var text = $(textField).val();

      $.ajax({
        url: "/admin/moderation/quickapprove/" + activityId,
        type: "POST",
        data: {
          text: text,
        },
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        success: function (data) {
          ePortfolio.processAjaxRespose(data, $(this));
        },
        error: function (data) {
          var errors = JSON.parse(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });
  };

  ePortfolio.convertToGroupActivity = function () {
    $(document).off("click", ".btn-convert2ga");
    $(document).on("click", ".btn-convert2ga", function (e) {
      // console.log('converting...');
      var button = $(this);
      button.button("loading");

      e.preventDefault();
      var opportunityId = $(this).attr("data-opportunity-id");
      var form = $("#convert-to-group-activity-form");
      var url = form.attr("action");
      var data = new FormData(form[0]);

      $.ajax({
        url: url,
        type: "POST",
        data: data,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data, $(this));
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });
  };

  ePortfolio.convertToGroupOpportunity = function () {
    $(document).off("click", ".btn-convert2group");
    $(document).on("click", ".btn-convert2group", function (e) {
      console.log("converting...");
      e.preventDefault();
      var form = $("#convert-to-group-opportunity-form");
      var url = form.attr("action");
      var data = new FormData(form[0]);
      var button = $(this);
      button.button("loading");

      $.ajax({
        url: url,
        type: "POST",
        data: data,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: { "X-CSRF-Token": $("meta[name=csrf-token]").attr("content") },
        success: function (data) {
          // console.dir(data);
          ePortfolio.processAjaxRespose(data, $(this));
        },
        error: function (data) {
          var errors = $.parseJSON(data.responseText);
          console.log(errors);
          $.each(errors, function (index, value) {
            toastr.error(value);
          });
        },
      });
    });
  };

  ePortfolio.canScroll = function () {
    $("body, html").css("overflow", "visible");
  };

  $(document).ready(function () {
    ePortfolio.initAjaxForm();
    ePortfolio.useCoordinatorsCheckbox();
  });

  ePortfolio.useCoordinatorsCheckbox = function () {
    $(document).off("change", "#use_coordinator");
    $(document).on("change", "#use_coordinator", function () {
      if ($(this).prop("checked")) {
        $("input[name=assessor_name]").prop("required", false);
        $("input[name=assessor_email]").prop("required", false);
      } else {
        $("input[name=assessor_name]").prop("required", true);
        $("input[name=assessor_email]").prop("required", true);
      }
    });
  };
})(jQuery);
